import { render, staticRenderFns } from "./Vedio.vue?vue&type=template&id=eb112f88&scoped=true"
import script from "./Vedio.vue?vue&type=script&lang=js"
export * from "./Vedio.vue?vue&type=script&lang=js"
import style0 from "./Vedio.vue?vue&type=style&index=0&id=eb112f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb112f88",
  null
  
)

export default component.exports